// packages/console/src/components/LivePlaybackPage.tsx
//
// The standalone live-playback "route". The console has no router, so a new tab
// is opened at the same origin with a "?play=<encoded master url>" query (see
// LiveTranscoder's Play button), and App renders THIS page instead of the
// transcoder when that param is present. It reads the minted ABR master URL from
// the query and plays it full-window through the shared LiveHlsPlayer.
//
// The minted URL is self-authenticating (its token rides in the query), so this
// tab needs no in-memory session: it renders standalone. When the param is
// missing or unparseable, it shows an honest empty state rather than a blank
// player (R10).

import { LiveHlsPlayer } from "./LiveHlsPlayer";
import { playbackUrlFromLocation, TITLE_PARAM } from "../lib/livePlayback";

export function LivePlaybackPage() {
  const url = playbackUrlFromLocation(window.location.search);
  const title = new URLSearchParams(window.location.search).get(TITLE_PARAM) || "Live playback";

  return (
    <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", background: "var(--bg-base)", color: "var(--fg1)" }}>
      <div style={{ flex: "none", display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", borderBottom: "1px solid var(--line)" }}>
        <span style={{ font: "600 12px var(--font-sans)", letterSpacing: ".08em", textTransform: "uppercase", color: "var(--fg3)" }}>
          {title}
        </span>
      </div>
      <div style={{ flex: 1, position: "relative", minHeight: 0, background: "#000" }}>
        {url ? (
          <LiveHlsPlayer url={url} />
        ) : (
          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", font: "var(--t-body-sm)", color: "var(--fg4)" }}>
            No playback URL. Open this page from the live console's Play button.
          </div>
        )}
      </div>
    </div>
  );
}
